"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTracking } from "react-tracking";
import { Text, MarkdownRenderer } from "@nxt-costco-com/forge-components";
import { VIEW_NAME_CALLOUT } from "./constants.js";
import { DEFAULT_CALLOUT_BACKGROUND_COLOR, DEFAULT_CALLOUT_TEXT_COLOR, StyledTileContainer, StyledCalloutContainer, StyledStaticCalloutContainer, StyledBodyContainer, StyledTitleContainer } from "./styles.js";
const CalloutCardContainer = ({ data }) => {
  var _a, _b;
  return /* @__PURE__ */ jsxs(StyledBodyContainer, { style: { height: "100%" }, children: [
    /* @__PURE__ */ jsx(StyledTitleContainer, { children: /* @__PURE__ */ jsx(
      Text,
      {
        sx: {
          color: (_b = (_a = data.card_styling) == null ? void 0 : _a.card_font_color) == null ? void 0 : _b.hex
        },
        component: "h2",
        children: data.feature_title
      }
    ) }),
    /* @__PURE__ */ jsx(
      MarkdownRenderer,
      {
        markdown: data.feature_caption,
        overrides: { code: Text, pre: Text }
      }
    )
  ] });
};
function CalloutCard({ data }) {
  var _a, _b, _c, _d, _e, _f;
  const { trackEvent } = useTracking();
  const onClickHandler = () => {
    trackEvent();
  };
  const buttonGroup = data.button_group;
  const costcoUrl = (_a = buttonGroup == null ? void 0 : buttonGroup.button_with_costco_url) == null ? void 0 : _a.url;
  const background = ((_c = (_b = data.card_styling) == null ? void 0 : _b.card_background_color) == null ? void 0 : _c.hex) || DEFAULT_CALLOUT_BACKGROUND_COLOR;
  const color = ((_e = (_d = data.card_styling) == null ? void 0 : _d.card_font_color) == null ? void 0 : _e.hex) || DEFAULT_CALLOUT_TEXT_COLOR;
  const disableThirdPartyTracking = (_f = data == null ? void 0 : data.privacy_toggle) == null ? void 0 : _f.disable_third_party_tracking;
  return /* @__PURE__ */ jsx(StyledTileContainer, { "data-testid": VIEW_NAME_CALLOUT, children: costcoUrl ? /* @__PURE__ */ jsx(
    StyledCalloutContainer,
    {
      sx: {
        background,
        color: `${color} !important`
      },
      href: costcoUrl,
      onClick: onClickHandler,
      ...disableThirdPartyTracking && { "data-private": "" },
      children: /* @__PURE__ */ jsx(CalloutCardContainer, { data })
    }
  ) : /* @__PURE__ */ jsx(
    StyledStaticCalloutContainer,
    {
      sx: {
        background,
        color: `${color} !important`
      },
      ...disableThirdPartyTracking && { "data-private": "" },
      children: /* @__PURE__ */ jsx(CalloutCardContainer, { data })
    }
  ) });
}
export {
  CalloutCard
};
